//View Keys
export default {
    fleet_export_modal_pdf_title: "Export Columns",
    fleet_export_modal_pdf_message: "You can select up to {{number}} columns to export in PDF format"
};
